import clsx from 'clsx';

type Background = 'white' | 'background-warm';
interface BoxProps {
  children: React.ReactNode;
  className?: string;
  background?: Background;
}

const backgroundClassNames: Record<Background, string> = {
  white: 'bg-white',
  'background-warm': 'bg-[#FAF9F7]',
};

export const Box = ({
  children,
  className,
  background = 'white',
  ...props
}: BoxProps) => {
  return (
    <div
      className={clsx(
        'rounded-lg border border-gray-200 p-4',
        backgroundClassNames[background],
        className,
      )}
      {...props}
    >
      {children}
    </div>
  );
};
